import { render, staticRenderFns } from "./DataSourceView.vue?vue&type=template&id=240c0fdc&"
import script from "./DataSourceView.vue?vue&type=script&lang=js&"
export * from "./DataSourceView.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceView.vue?vue&type=style&index=0&id=240c0fdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports